<div class="card">
    <div class="card-header text-center bg-file-header">
        <h4>
            Arquivos Gerados
            <i *ngIf="loading" class="fa fa-spinner fa-spin fa-2x float-right text-warning"></i>
        </h4>
    </div>

    <div class="card-body">
        <div class="automatic-debit-table-component" *ngIf="fileListPaginated.length > 0">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th scope="col">Data</th>
                        <th scope="col">Arquivo</th>
                        <th scope="col">Qtd Itens</th>
                        <th scope="col">Usuário</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let file of fileListPaginated; let i = index">
                        <td>{{ file.generatedDate | date: 'dd/MM/yyyy' }}</td>
                        <td>{{ file.fileName }}</td>
                        <td>{{ file.items.length }}</td>
                        <td>{{ file.userName }}</td>

                        <td class="float-right">
                            <button (click)="downloadFile(file)" class="btn btn-success btn-sm mr-3">
                                Download
                                <i class="flaticon-download-1 text-white"></i>
                            </button>

                            <button class="btn btn-sm btn-primary" (click)="openModal(file)">
                                Visualizar
                                <span class="fa fa-angle-right mf-3"></span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="d-flex justify-content-between p-2">
                <ngb-pagination
                    [collectionSize]="collectionSize"
                    [(page)]="page"
                    [pageSize]="pageSize"
                    (pageChange)="loadPaginator()">
                </ngb-pagination>

                <select
                    class="custom-select"
                    style="width: auto"
                    [(ngModel)]="pageSize"
                    (ngModelChange)="loadPaginator()">
                    <option [ngValue]="10">10 por pág.</option>
                    <option [ngValue]="20">20 por pág.</option>
                    <option [ngValue]="50">50 por pág.</option>
                    <option [ngValue]="100">100 por pág.</option>
                </select>
            </div>
        </div>
    </div>
</div>
